import { getToken } from '../../Utils/authUtils';
import { REPORTS } from '../../constant';

export async function saveDiagramHtml(reportId: string, diagramHtml: string): Promise<void> {
  try {
    await fetch(REPORTS.SAVE_DIAGRAM_HTML, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken(),
      },
      body: JSON.stringify({ reportId, diagramHtml }),
    });
  } catch {
    // silent — diagram save is best-effort, must not break report flow
  }
}
